import React, { useState, useEffect } from 'react';
import { Puzzle, UserPlus, TrendingUp, Target, MessageSquare, Users } from 'lucide-react';
import './OurCultureValues.css';

const TeamValuesSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const values = [
    {
      icon: <Puzzle size={36} />,
      title: "People Cohesion",
      description: "More and less froze grumbled ran hawk mindfully tearfully pending crud.",
      color: "#3d4450"
    },
    {
      icon: <UserPlus size={36} />,
      title: "Team Leadership",
      description: "A less until infallible indistinct decided inventoried gosh hey some contemplated.",
      color: "#c94449"
    },
    {
      icon: <TrendingUp size={36} />,
      title: "Team Build Up",
      description: "Irritably punctiliously ahead far away groundhog darn contrary and fish underneath.",
      color: "#3d4450"
    },
    {
      icon: <Target size={36} />,
      title: "Strategy",
      description: "Jeez alas after squarely excellent incessant on less vulgarly checked pertly.",
      color: "#c94449"
    },
    {
      icon: <MessageSquare size={36} />,
      title: "Communication",
      description: "Flustered precarious jeez unexpectedly overrode glowered away goodness.",
      color: "#3d4450"
    },
    {
      icon: <Users size={36} />,
      title: "Employee Search",
      description: "Objectively pursue diverse catalysts for change for interoperable meta-services.",
      color: "#c94449"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % Math.ceil(values.length / 2));
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [values.length]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const getVisibleCards = () => {
    const startIndex = currentSlide * 2;
    return values.slice(startIndex, startIndex + 2);
  };

  return (
    <div className="team-values-wrapper">
      <div className="team-values-container">
        <div className="values-content-section">
          <div className="values-header">
            <p className="values-subtitle">JOIN THE LEADING TEAM</p>
            <h1 className="values-title">
              <span className="values-title-highlight">What do we  <span className="values-title-dark">Stand for?</span></span>
             
            </h1>
            <p className="values-description">
              Nanotechnology immersion along the information highway will close the loop on focusing solely on the bottom line.
            </p>
          </div>

          <div className="values-slider-wrapper">
            <div className="values-cards-grid">
              {getVisibleCards().map((value, index) => (
                <div key={currentSlide * 2 + index} className="value-card slide-in">
                  <div className="value-icon-circle" style={{ backgroundColor: value.color }}>
                    {value.icon}
                  </div>
                  <h3 className="value-card-title">{value.title}</h3>
                  <p className="value-card-description">{value.description}</p>
                </div>
              ))}
            </div>

            <div className="slider-dots">
              {Array.from({ length: Math.ceil(values.length / 2) }).map((_, index) => (
                <button
                  key={index}
                  className={`dot ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="values-image-section">
          <div className="organic-shape-wrapper">
            <img 
              src="/images/docu1.png" 
              alt="Team collaboration"
              className="team-values-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamValuesSection;